<style>
</style>
<template>
    <div>
    <div class="form-group">
        <label for="search-perpage">每頁數量</label>
        <select id="search-perpage" name="perpage" v-model="inputs.perpage">
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="9999">9999</option>
        </select>
    </div>
    <div class="form-group">
        <label for="search-user">用戶</label>
        <select id="search-user" name="user_uuid" v-model="inputs.user_uuid">
          <option value="">未選擇</option>
            <option v-bind:value="user.uuid" v-for="user of users">{{user.name}}</option>
        </select>
    </div>
    <div class="form-group">
        <label for="search-month">月份</label>
        <select id="search-month" name="month" v-model="inputs.month">
          <option value="">未選擇</option>
            <option v-bind:value="month" v-for="month of months">{{month}}</option>
        </select>
    </div>
    <div class="form-group">
        <label class="checkbox">
          <input type="checkbox" name="trashed" v-model="inputs.trashed">顯示已刪除
        </label>
    </div>
    <div class="form-group">
        <label class="checkbox">
          <input type="checkbox" name="waged" v-model="inputs.waged">顯示已結算
        </label>
    </div>
    <div class="form-group">
        <input type="submit" value="送出" class="btn btn-default btn-sm">
    </div>
    </div>
</template>

<script>
  export default {
    props: [
      'users',
      'default-inputs',
    ],

    computed: {
      months: function () {
        let now = new Date;
        let result = [];

        for (let i = 0; i < 12; i++) {
          const month = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).substr(-2, 2);
          result.push(month);
          now.setMonth(now.getMonth() - 1);
        }

        return result;
      },
    },

    data() {
      let data = this.defaultInputs;
      let defaultData = {
        perpage: '30',
        user_uuid: '',
      }

      data = Object.assign(defaultData, data);

      return {
        inputs: data
      }
    },

    methods: {
    },

    mounted() {
    }
  }
</script>
